import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import { AuthProvider } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import Homepage from './views/Homepage';
import Loginpage from './views/Loginpage';
import Dashboard from './views/Dashboard';
import Navbar from './views/Navbar';
import EmployesPage from "./views/EmployesPage";

import JustificationsPage from './views/JustificationsPage.js';

import PresencePage from './views/PresencePage';
import PresenceHistoriquePage from './views/PresenceHistoriquePage';
import ListAbscence from './views/ListAbscence';
import AbsenceEmployePage from './views/AbsencesEmployePage';
import MesPresencesPage from './views/MesPresencesPage';
import NotificationPermission from "./components/NotificationPermission";
import NotificationListener from "./components/NotificationListener";

import ConfigurationPage from './views/ConfigurationPage';
import ModifierCompte from './views/ModifierCompte';
import EmployeList from './views/EmployeList';
import EmployeDetail from './views/EmployeDetail';
import HeuresTravaillees from './views/HeuresTravaillees';
import MesRetardsPage from './views/MesRetardsPage'; 
import ValidationRetardsRHPage from './views/ValidationRetardsRHPage';
import PenalitesPage from './views/PenalitesPage';
import PrimesPage from './views/PrimesPage';

import ActivitesPage  from './views/ActivitePage.js';
import PresenceExceptionnellePage  from './views/PresenceExceptionnellePage.js';
import HeureSupplementairePage  from './views/HeureSupplementairePage.js';

import RHStatsPage from "./views/RHStatsPage";
import RHStatsDetailPage  from "./views/RHStatsDetailPage.js";
import OrganisationPage  from "./views/OrganisationPage.js";


import EmployeePermissionsPage from './views/EmployeePermissionsPage';

import SuperAdminEmployePage from './views/SuperAdminEmployeesPage.js';
import PointageManuelPage from './views/PointageManuelPage.js';
import About from './views/About.js';
import RolesPage from './views/RolesPage.js';
import RoleEmployePage from './views/RoleEmployePage.js';
import ForgotPasswordPage from './views/ForgotPasswordPage.js';
import ResetPasswordPage from './views/ResetPasswordPage.js';
import GestionHeuresSupPage from './views/GestionHeuresSupPage.js';
import GestionInnovationPage from './views/GestionInnovationPage';
import MesEvaluationsInnovation from './views/MesEvaluationsInnovation.js';
import MesEvaluationsPage from './views/MesEvaluationsPage.js';
import GestionAbsencesRetards from './views/GestionAbsencesRetards.js';



function App() {
  return (
    <Router>
      <AuthProvider>
        <SidebarProvider>
        <Navbar />
        <NotificationPermission />  
        <NotificationListener />

        <Routes>

          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/login" element={<Loginpage />} />
          <Route path="/" element={<Homepage />} />
          <Route path="/employes" element={<EmployesPage />} />



          <Route path="/presence" element={<PresencePage />} />  
          <Route path="/historique-presences" element={<PresenceHistoriquePage />} />
          <Route path="/absences" element={<AbsenceEmployePage />} />
          <Route path="/liste-abscences" element={<ListAbscence />} />
          <Route path="/modifier-compte" element={<ModifierCompte />} />

          <Route path="/justifications" element={<JustificationsPage />} />
          <Route path="/mes-presences" element={<MesPresencesPage />} />
          <Route path="/configuration" element={<ConfigurationPage />} />

          <Route path="/employes-presence" element={<EmployeList />} />
          <Route path="/employes/:id" element={<EmployeDetail />} />
          <Route path="/heure" element={<HeuresTravaillees />} />
          <Route path="/mes-retards" element={<MesRetardsPage />} />
          <Route path="/retards" element={<ValidationRetardsRHPage />} />
          <Route path="/penalites" element={<PenalitesPage />} />
          <Route path="/primes" element={<PrimesPage />} />
          <Route path="/activites" element={<ActivitesPage />} />
          <Route path="/presence-exeptionnelle" element={<PresenceExceptionnellePage />} />
          <Route path="/heure-sup" element={<HeureSupplementairePage />} />
          <Route path="/stats" element={<RHStatsPage />} />
          <Route path="/statsDetail" element={<RHStatsDetailPage />} />
          <Route path="/organisations" element={<OrganisationPage />} />
          <Route path="/permissions/employe/:id" element={<EmployeePermissionsPage />} />
          <Route path="/superadmin" element={<SuperAdminEmployePage />} />
          <Route path="/pointage-manuels" element={<PointageManuelPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/role" element={<RolesPage />} />
           <Route path="/employes/:id/role" element={<RoleEmployePage />} /> 
          <Route path="/mot-de-passe-oublier" element={<ForgotPasswordPage />} />
<Route path="/reset-password/:userId/:token" element={<ResetPasswordPage />} />          

<Route path="/heures-sup" element={<GestionHeuresSupPage />} /> 
<Route path="/innovations" element={<GestionInnovationPage />} />
<Route path="/mes-evaluations-innovation" element={<MesEvaluationsInnovation />} />
  <Route path="/mes-evaluations" element={<MesEvaluationsPage />} />
<Route path="/gestion-absences-retards" element={<GestionAbsencesRetards />} />

        </Routes>
        </SidebarProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

